import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import CertificateProp from '../../sections/academy/propTypes/certificateProp';
import CertificatePreview from '../../sections/certificate/CertificatePreview';
import UserColumn from '../lists/columns/UserColumn';

const CertificateItem = ({ t, certificate }) => {
  const { owner } = certificate;
  return (
    <div>
      <CertificatePreview
        certificate={certificate}
        appProducts={[]}
        cards={[]}
        appName=""
        user={{}}
        countries={[]}
      />
      <div className="user-column-container"><UserColumn t={t} user={owner} /></div>
    </div>
  );
};

CertificateItem.propTypes = {
  t: PropTypes.func.isRequired,
  certificate: PropTypes.shape(CertificateProp.propType).isRequired,
};

export default translate(CertificateItem);
